import { render, staticRenderFns } from "./ArticleDetailCommentList.vue?vue&type=template&id=9b30dce2&"
import script from "./ArticleDetailCommentList.vue?vue&type=script&lang=js&"
export * from "./ArticleDetailCommentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports